<template>
    <div class="block-view">
       <div class="mt-3 pt-3">
          <nav class="breadcrumb-wrapper" aria-label="breadcrumb">
             <ol class="breadcrumb">
                <li class="breadcrumb-item clickable-row" aria-current="page" @click="goToMainPage">Content Block</li>
                <li class="breadcrumb-item" aria-current="page"> Block View </li>
             </ol>
          </nav>
       </div>
 
       <div>
          <BlockDetailedView :id="id" @blockTitle="getBlockTitle"/>
       </div>
 
    </div>
 
    <!-- <div>
 
       <div class="text-center">
          <nav class="breadcrumb-wrapper" aria-label="breadcrumb">
             <ol class="breadcrumb">
                <li class="breadcrumb-item" aria-current="page">Page Not Found</li>
             </ol>
          </nav>
       </div>
 
    </div> -->
 </template>
 
 <script>
 import BlockDetailedView from "@/components/ContentLibrary/BlockDetailedView.vue"
 
 export default ({
 
    components: {
        BlockDetailedView
    },
 
    props: {
       id: {
          type: String,
       },
    },
 
    data() {
       return {
          title: "",
          organisationId: 0,
       }
    },
 
    computed: {
       item() {
          return this.id
       },
 
       currentOrg() {
          return this.$store.state.auth.currentOrganisation.id
       }
 
    },
 
    watch: {
       item() {
          this.init()
       },
 
       currentOrg() {
          this.$router.push({ name: 'audits' })
       }
 
    },
 
    created(){
       this.organisationId = this.$store.state.auth.currentOrganisation.id
    },
 
    methods: { 
 
       getBlockTitle({title}){
          this.title = title
          
       },
 
       goToMainPage() {
          this.$router.push({ name: 'content_library_blocks' })
       }
    },
 })
 </script>
 
 <style scoped>
 
 .clickable-row:hover{
    text-decoration: underline;
 }
 
 </style>